import { styled } from '@mui/system';
import BoxMui from '@mui/material/Box';

type Params = {
    product: boolean;
    price: string;
    cents: string;
    priceYearly: string;
    installationValue?: number;
    produtO_ATUAL: boolean;
}

const ContainerPrice = styled('div')(
    ({ theme }) => `
        width: 100%;
        display: flex;
        padding: .8rem 0 .5rem;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        p {
            margin: 0;
            padding: 0;
            line-height: 1;
        }

        .remark {
            width: 100%;
            height: 3.5rem;
            display: flex;
            padding-top: 5px;
            flex-direction: column;
            justify-content: start;

            p {
                font-weight: 600;
                line-height: 17px;
                font-size: .875rem;
                color: ${theme.palette.grey[300]};
            }
        }
`)

const Price = styled(BoxMui)(
    ({ theme }) => `
        display: grid;
        width: fit-content;
        align-items: center;
        grid-template-columns: auto 1fr auto;
        grid-template-rows: auto auto;

        grid-template-areas:
          'currency integer decimal'
          '. integer period';

        .currency {
            font-size: 1.23rem;
            font-weight: 700;
            grid-area: currency;
            margin-right: .25rem;
        }

        .integer, .decimal {
            font-weight: 700;
            font-size: 3.8rem;
            grid-area: integer;
        }

        .decimal {
            grid-area: decimal;
            font-size: 1.8rem;
        }

        .period {
            font-size: 1.123rem;
            font-weight: 700;
            grid-area: period;
        }
`)

const PriceCard = ({ product, price, cents, priceYearly, installationValue, produtO_ATUAL }: Params) => {
    return (
        <ContainerPrice>
            <Price>
                <p className='currency'>
                    R<span className="dolar">$</span>
                </p>
                <p className='integer' style={{ color: produtO_ATUAL ? "#17A7E0" : "#97C93D" }}>
                    {price}
                </p>
                <p className='decimal' style={{ color: produtO_ATUAL ? "#17A7E0" : "#97C93D" }}>
                    ,{cents}
                </p>
                <p className='period'>
                    /MÊS
                </p>
            </Price>
            <div className="remark">
                {installationValue ?
                    <p>+ Instalação: R$ {`${installationValue.toFixed(2)}`.replace('.', ',')}</p>
                    :
                    <p> + Instalação grátis </p>
                }
                {product && <p>Valor anual: {priceYearly}</p>}
            </div>
        </ContainerPrice>
    )
}

export default PriceCard;